const inline = (text) => {
  const parts = text.split(/(\*\*[^*]+\*\*|_\([^)]*\)_)/g);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) return <strong key={i}>{p.slice(2, -2)}</strong>;
    if (p.startsWith("_(") && p.endsWith(")_")) return <em key={i}>{p.slice(1, -1)}</em>;
    return <span key={i}>{p}</span>;
  });
};

export const SectionBody = ({ body }) => {
  const lines = body.split("\n").map((l) => l.trim()).filter(Boolean);
  const out = [];
  let bullets = [];
  const flush = () => {
    if (bullets.length) out.push(<ul key={`u${out.length}`} className="list-disc pl-6 space-y-1 mb-3">{bullets}</ul>);
    bullets = [];
  };
  lines.forEach((l, i) => {
    if (l.startsWith("- ")) bullets.push(<li key={i}>{inline(l.slice(2))}</li>);
    else { flush(); out.push(<p key={i} className="mb-3">{inline(l)}</p>); }
  });
  flush();
  return <>{out}</>;
};

export const ContractSections = ({ sections }) => (
  <div className="space-y-7" data-testid="contract-sections">
    {sections.map((s) => (
      <section key={s.key} data-testid={`contract-section-${s.key}`}>
        <h3 className="font-label text-xs mb-3" style={{ color: "var(--ss-rust)" }}>{s.title}</h3>
        <div className="font-body text-sm leading-relaxed" style={{ color: "var(--ss-cream-dim)" }}>
          <SectionBody body={s.body} />
        </div>
      </section>
    ))}
  </div>
);

export const SummaryTable = ({ rows, testId = "contract-summary" }) => (
  <div className="border" style={{ borderColor: "var(--ss-border)" }} data-testid={testId}>
    {rows.map(([k, v]) => (
      <div key={k} className="grid grid-cols-5 gap-3 px-4 py-2.5 border-b last:border-b-0 text-sm" style={{ borderColor: "var(--ss-border)" }}>
        <div className="col-span-2 font-label text-[0.6rem] pt-1" style={{ color: "var(--ss-muted)" }}>{k}</div>
        <div className="col-span-3 break-words">{v || "—"}</div>
      </div>
    ))}
  </div>
);
